export default __webpack_public_path__ + "static/media/modal-warning.76f3d9a6.png";